export default __webpack_public_path__ + "static/media/professional-photo.912567da.png";